/* Bisou Rivage — galerie produit : fleches (style footer) + cercles + retour slide 1 au changement de variante.
 * Isole & additif. Le swipe/fleches restent geres par le <slider-component> natif (SliderComponent).
 * Ne touche pas a variant-ui, product-form, cart. Reversible (retirer ce fichier + sa balise). */
(function () {
  var SVG_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12H4M10 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init() {
    var root = document.querySelector('[data-bisou-gallery="slider"]');
    if (!root) return;
    var list = root.querySelector('.product__media-list');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll(':scope > li.product__media-item'));
    if (slides.length < 2) return;

    // fleches facon footer (avec queue) — on remplace juste l'icone, pas la logique du bouton
    var pv = root.querySelector('.slider-button--prev .svg-wrapper') || root.querySelector('.slider-button--prev');
    var nx = root.querySelector('.slider-button--next .svg-wrapper') || root.querySelector('.slider-button--next');
    if (pv) pv.innerHTML = SVG_PREV;
    if (nx) nx.innerHTML = SVG_NEXT;

    // cercles
    var dots = document.createElement('div');
    dots.className = 'bisou-gdots';
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bisou-gdot';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', function () {
        list.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    var nav = root.querySelector('.slider-buttons');
    if (nav) {
      var counter = nav.querySelector('.slider-counter');
      nav.insertBefore(dots, counter ? counter.nextSibling : null);
    } else {
      root.appendChild(dots);
    }

    function setActive(idx) {
      for (var i = 0; i < dots.children.length; i++) {
        dots.children[i].classList.toggle('is-active', i === idx);
      }
    }
    function current() {
      var mid = list.scrollLeft + list.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.clientWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }

    setActive(0);
    var raf;
    list.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(current()); });
    });
    window.addEventListener('resize', function () { setActive(current()); });

    document.addEventListener('bisou:variant-change', function () {
      list.scrollTo({ left: 0, behavior: 'smooth' });
      setActive(0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
